<template>
  <div class="Rank">
    <side_bar :links="links"></side_bar>
    <r_header v-if="!$store.state.mediaPhone"></r_header>
    <div class="camp" @click="camp" v-if="false">
      <div>
        冬令营火热报名中！晋级国赛选手可以获得奖学金。
      </div>
      <img src="/oss/aiyouth2022/images/winter-camp-qr.png" />
    </div>
    <div v-if="user">
      <my_rank v-if="procedure == 0" :info="myRank"></my_rank>
    </div>
    <div class="group" v-if="procedure<5">
      <div class="grp fs20" :class="{focus: leaderboard=='personal' }"  @click="focus('personal')">个人排名</div>
      <div class="grp fs20" :class="{focus: leaderboard=='organization'}"  @click="focus('organization')">学校排名</div>
    </div>
    <div v-if="leaderboard == 'personal'">
      <rank v-if="procedure == 1 || procedure == 3" :procedure="procedure"></rank>
    </div>
    <div v-else>
      <school_rank v-if="procedure == 1 || procedure == 3" :procedure="procedure"></school_rank>
    </div>
  </div>
</template>

<script>
 // @ is an alias to /src

 import SideBar from '@/components/SideBar.vue';
 import RHeader from '@/components/frontpage/Header.vue';
 import MyRank from '@/components/score/MyRank.vue';
 import Rank from '@/components/score/Rank.vue';
 import RepRank from '@/components/score/RepRank.vue';
 import Prelim from '@/components/score/Prelim.vue';
 import TempPrelim from '@/components/score/TempPrelim.vue';
 import Final from '@/components/score/Final.vue';
 import Result from '@/components/score/Result.vue';
  import SchoolRank from '@/components/score/SchoolRank.vue';
  import SchoolRepRank from '@/components/score/SchoolRepRank.vue';
import moment from 'moment'
 export default {
   name: 'Rank',
   computed: {
     links () {
       return this.$store.state.sbar.linksFP
     },
     user() {
       return this.$store.state.auth.user
     },
        group() {
       return ['小学组', '中学组', '开放组']
        },
     procedure() {
       return this.$store.state.procedure
     },
     correctTime() {
       return moment(+new Date() + this.$store.state.timeDelay)
     },
     tempProcedure () {
       if(this.correctTime.isBefore('2022-12-15') && this.correctTime.isAfter('2022-11-15 00:00:00')) {
         return 1.5
       }
       return 0
     },
     game_year() {
       return this.$store.state.game_slug.slice(0, 4)
     },
     reward () {
       if(this.user)
       return this.$store.state.auth.game_state[this.game_year+'-2'].state >= 1
       else
         return false
     }
   },
    methods: {
      focus(f) {
        this.leaderboard = f;
      },
      camp () {
        window.open('https://vvf.xet.tech/s/2SQQpl', '_blank')
      }
    },
   data () {
     return  {
       myRank: {
         '姓名': '__',
         '组别': '__',
         '学校/机构': '__',
         '积分': '__',
       },
       score: null,
       passed: false,
       leaderboard: 'personal',
     }
   },
   mounted() {
     let group = this.group;
     if(this.user){
       if( this.user.enrolled&&this.procedure == 1)
       {
         this.$http.get('/api/rank?user_id='+this.user.id)
             .then(res=>{
               this.myRank = {
                 '姓名': res.extra.username,
                 '组别': group[this.user.group-1],

                 '学校/机构': this.user.organization,
                 '积分': res.extra.ozaria
             /* '区域': res.extra.area_name, */
             /* '积分/全国排名': `${res.extra.score}/${res.extra.rank}`, */
               }
               this.passed = (res.extra.score != "尚未进入竞技场" || res.extra.ozaria !=  '尚未进入竞技场')
         })
       }
     else{
       this.myRank={
         '姓名': this.user.name,
         '组别': '/',
         '学校/机构': '/',
         '积分': '/',
       }
     }
     }
   },

   components: {
     r_header: RHeader,
     my_rank: MyRank,
     prelim: Prelim,
     final: Final,
     rank: Rank,
     reprank: RepRank,
     side_bar: SideBar,
     school_rank: SchoolRank,
     school_reprank: SchoolRepRank,
     result: Result,
     TempPrelim
   }
 }
</script>

<style scoped>
  .wait {
    margin: 200px;
    text-align: center;
    font-size: xx-large;

  }
 .group{
   display: flex;
   align-items:center;
   justify-content: space-around;
   width: 100vw;
   border-bottom: 1px dashed black;
   margin-bottom: 1.5625vw;
   margin-top: 5vw ;
 }
 .grp{
   line-height: 2.5vw;
 }
 .focus{
   border-bottom: 1px solid black;
   color: #4411FF;
 }
.camp {
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
  font-size: 24px;
}

.camp > img {
  margin-top: 10px;
  width: 200px;
}
</style>